import PubSub from "pubsub-js";
import gsap from 'gsap';
import Draggable from 'gsap/Draggable';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(Draggable, ScrollTrigger);

var CommunityEngagementQuoteCards = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-CommunityEngagementQuoteCards',
	};

	$.extend(true, this.options, options);

};

CommunityEngagementQuoteCards.prototype.init = function() {

	var self = this;

	this.initialPositionPercents = [
		{ x: 0, y: 20 },
		{ x: 15.8, y: 100 },
		{ x: 23.4, y: 0 },
		{ x: 46.8, y: 42 },
		{ x: 67.5, y: 13 },
		{ x: 82, y: 94 },
		{ x: 100, y: 32 },
	];

	this.$quoteCardsContainer = this.options.$el.find(`.${self.options.baseClass}__quoteCardsWrapper`);
	this.$quoteCardWrappers = this.options.$el.find(`.${self.options.baseClass}__quoteCardWrapper`);
	this.$quoteCards = this.options.$el.find(`.${self.options.baseClass}__quoteCard`);

	// make cards draggable
	Draggable.create(self.$quoteCardWrappers, {
	    type: "x,y",
	    edgeResistance: 0.8,
	    bounds: self.$quoteCardsContainer
	});

	// set initial card positions
	this.setInitialQuoteCardPositions();

	PubSub.subscribe("resized", function(){
		self.setInitialQuoteCardPositions();
	});

	// animate cards in
	this.animateIn();

};

CommunityEngagementQuoteCards.prototype.animateIn = function() {

	var self = this;

	// animate in when component is in viewport
	gsap.timeline(
		{
			scrollTrigger: {
				trigger: self.options.$el.find(`.${self.options.baseClass}__componentWrapper`),
				start: '70% bottom',
				// markers: true,
			},
			delay: 0
		}
	)
	.to(self.$quoteCards,
		{
			duration: 0.4,
			ease: "power1.out",
			opacity: 1,
			stagger: {
				each: 0.08
			},
			//ease: "power1.out",
		},
		"<"
	)
	.to(self.$quoteCards,
		{
			duration: 0.6,
			ease: "back.out(1.5)",
			scale: 1,
			stagger: {
				each: 0.1
			},
			//ease: "power1.out",
		},
		"<"
	);

};

CommunityEngagementQuoteCards.prototype.setInitialQuoteCardPositions = function() {

	var self = this;

	var containerWidth = this.$quoteCardsContainer.width();
	var containerHeight = this.$quoteCardsContainer.height();

	for (var i = 0; i < self.initialPositionPercents.length; i++) {

		var $quoteCard = self.$quoteCardWrappers.eq(i);

		var quoteCardWidth = $quoteCard.outerWidth();
		var quoteCardHeight = $quoteCard.outerHeight();

		var x = (self.initialPositionPercents[i].x / 100) * (containerWidth - quoteCardWidth);
		var y = (self.initialPositionPercents[i].y / 100) * (containerHeight - quoteCardHeight);

		gsap.set($quoteCard, {
			x: x,
			y: y
		});

	}

	if (self.initialPositionPercents.length < self.$quoteCards.length) {

		for ( var i = self.initialPositionPercents.length; i < self.$quoteCards.length; i++ ) {
			
			var $quoteCard = self.$quoteCardWrappers.eq(i);

			var quoteCardWidth = $quoteCard.outerWidth();
			var quoteCardHeight = $quoteCard.outerHeight();

			var x = Math.random() * (containerWidth - quoteCardWidth);
			var y = Math.random() * (containerHeight - quoteCardHeight);

			gsap.set($quoteCard, {
				x: x,
				y: y
			});

		}

	}

};

export default CommunityEngagementQuoteCards;
